import { useCallback } from 'react';
import { useTurnaroundDestinationEntities } from './useTurnaroundDestinationEntities';
import { useTurnaroundOriginDeliveryId } from './useTurnaroundOriginDeliveryId';
import { useTurnaroundDestinationDeliveryId } from './useTurnaroundDestinationDeliveryId';
import { useTurnaroundDestinationSelectedEntities } from './useTurnaroundDestinationSelectedEntities';
import { useTurnaroundOriginSelectedEntities } from './useTurnaroundOriginSelectedEntities';
import { useTurnaroundSupplier } from './useTurnaroundSupplier';
import { useTurnaroundDestinationForm } from './useTurnaroundDestinationForm';
import { useTurnaroundOriginForm } from './useTurnaroundOriginForm';
import { useHasSearchedForDestinationDeliveries } from './useHasSearchedForDestinationDeliveries';

export const useTurnaroundFormReset = () => {
  const setTurnaroundSupplier = useTurnaroundSupplier()[1];
  const setTurnaroundOriginDeliveryId = useTurnaroundOriginDeliveryId()[1];
  const setTurnaroundOriginSelectedEntities = useTurnaroundOriginSelectedEntities()[1];
  const setTurnaroundDestinationDeliveryId = useTurnaroundDestinationDeliveryId()[1];
  const setTurnaroundDestinationEntities = useTurnaroundDestinationEntities()[1];
  const setTurnaroundDestinationSelectedEntities = useTurnaroundDestinationSelectedEntities()[1];
  const setTurnaroundOriginForm = useTurnaroundOriginForm()[1];
  const setTurnaroundDestinationForm = useTurnaroundDestinationForm()[1];
  const setHasSearchedForDestinationDeliveries = useHasSearchedForDestinationDeliveries()[1];

  const turnaroundFormReset = useCallback(() => {
    setTurnaroundSupplier(null);
    setTurnaroundOriginDeliveryId(null);
    setTurnaroundOriginSelectedEntities([]);
    setTurnaroundDestinationDeliveryId(null);
    setTurnaroundDestinationEntities([]);
    setTurnaroundDestinationSelectedEntities([]);
    setTurnaroundOriginForm({
      orderNumber: '',
      surgeryReference: '',
      deliveryNumber: '',
      surgeon: null,
      surgeryDate: undefined,
    });
    setTurnaroundDestinationForm({
      orderNumber: '',
      surgeryReference: '',
      deliveryNumber: '',
      surgeon: null,
      surgeryDate: undefined,
    });
    setHasSearchedForDestinationDeliveries(false);
  }, [
    setTurnaroundSupplier,
    setTurnaroundOriginDeliveryId,
    setTurnaroundOriginSelectedEntities,
    setTurnaroundDestinationDeliveryId,
    setTurnaroundDestinationEntities,
    setTurnaroundDestinationSelectedEntities,
    setTurnaroundOriginForm,
    setTurnaroundDestinationForm,
    setHasSearchedForDestinationDeliveries,
  ]);

  return turnaroundFormReset;
};
